import * as Animatable from 'react-native-animatable'
import { ExtendingFooterStyles } from 'styles/scenes/home/book/_components/ExtendingFooter'
import { FooterStyles } from 'styles/components/organisms/Footer'
import { StyleSheet, Pressable, ScrollView, View } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import HelperPlatform from 'utils/helper-platform'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useIsSmallDevice } from 'utils/helper-device'
import HelperString from 'utils/helper-string'
import _ from 'lodash'
import ThemedPressable from 'components/atoms/ThemedPressable'
import HelperAnimation from 'utils/helper/HelperAnimation'
import HelperTestID from 'utils/HelperTestID'
import { TESTID } from '_shared/config/testID'
import IconWithCounter from 'components/molecules/IconWithCounter'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Icon from 'components/atoms/Icon'
import { layoutStyles } from 'styles/layout'


const ExtendingFooter = ({ button, buttonVisible = true, content = null, contentIcon, contentIconCount = 0, contentExtended, contentVisible = true, extended = false, onPressExtend = () => {
}, onHeight, testID = null }) => {
	const scrollViewRef = useRef( null );
	const handleBackgroundRef = useRef( null );
	const handleContainerRef = useRef( null );
	const [ height, setHeight ] = useState( 0 )
	
	const insets = useSafeAreaInsets();
	const isSmallDevice = useIsSmallDevice();
	const isDesktopWeb = HelperPlatform.isWeb() && !isSmallDevice;
	
	useEffect( () => {
		if ( extended === true ) {
			HelperAnimation.fadeIn( handleBackgroundRef );
		} else {
			HelperAnimation.fadeOut( handleBackgroundRef );
		}
	}, [ extended ] );
	
	useEffect( () => {
		if( _.isFunction( onHeight ) ) {
			onHeight( height )
		}
	}, [ height ])
	
	let containerStyle = {
		paddingBottom: insets?.bottom > 0 ? insets?.bottom : 12,
		paddingTop: !contentVisible ? 12 : 0
	}
	
	if( HelperPlatform.isWeb() ) {
		containerStyle = {
			...containerStyle,
			width: '100%',
			left: 0,
			right: 0,
		}
	}
	
	let buttonView = null
	if( buttonVisible && !extended ) {
		buttonView = (
			<View
				key={ 'buttonView' }
				style={ [
					ExtendingFooterStyles.buttonContainer,
					isDesktopWeb ? ExtendingFooterStyles.buttonContainerDesktop : null,
				] }>
				{ button }
			</View>
		)
	}
	
	let contentView = null;
	if( contentVisible ) {
		const collapsedContent = (
			<ThemedPressable
				key={ HelperString.hash('extending-footer-closed') }
				style={ staticStyles.themedPressableWidth100HeightAuto }
				onPress={ onPressExtend.bind( this, true ) }>
				
				<View
					style={ ExtendingFooterStyles.bookingsContainer }>
					
					<View key={ 'extendingFooterContent' } style={ [ ExtendingFooterStyles.timeslotSingleLeft ] }>
						{ content ?? null }
					</View>
					
					<View key={ 'extendingFooterSingle' } style={ ExtendingFooterStyles.timeslotSingleRight }>
						<IconWithCounter icon={ contentIcon } count={ contentIconCount }/>
					</View>
				</View>
			</ThemedPressable>
		);

		contentView = isDesktopWeb ? (
			<View style={ ExtendingFooterStyles.contentDesktop }>
				{ collapsedContent }
			</View>
		) : collapsedContent;
		
		if( extended ) {
			contentView = (
				<View
					key={ HelperString.hash('extending-footer-extended') }
					style={ [
						ExtendingFooterStyles.bookingsContainer,
						ExtendingFooterStyles.bookingsContainerExtended
					]}>
					
					<View style={ layoutStyles.flexOne }>
						<ScrollView
							ref={ scrollViewRef }
							horizontal={ false }
							showsVerticalScrollIndicator={ false }>
							
							{ contentExtended }
						</ScrollView>
					</View>
				</View>
			)
		}
	}
	
	let darkBackground = null;
	let closeButton = null;
	
	if ( extended ) {
		darkBackground = (
			<Animatable.View
				key={ 'darkBackground' }
				ref={ handleBackgroundRef }
				style={ ExtendingFooterStyles.overlay }
			/>
		);
		
		closeButton = (
			<View style={ ExtendingFooterStyles.overlayCloseButton }>
				<Pressable onPress={ onPressExtend.bind( this, false ) } testID={ HelperTestID.generate( testID, [ TESTID.HOME.BOOK.BOOKING_FOOTER.SUFFIX_EXTENDING_FOOTER_CLOSE_BUTTON ] ) }>
					<Icon icon={ IconSystemConstants.CLOSE } size={ 32 } />
				</Pressable>
			</View>
		);
	}
	
	let view = (
		<View
			key={ 'extendingFooter-view' }
			onLayout={(event) => {
				const { height: height1 } = event.nativeEvent.layout;
				
				if( height !== height1 ) {
					setHeight( height1 )
				}
			}}
			ref={ handleContainerRef }
			style={ [
				FooterStyles.container,
				containerStyle,
				ExtendingFooterStyles.container,
				isDesktopWeb && !extended ? ExtendingFooterStyles.containerDesktop : null,
				extended ? ExtendingFooterStyles.containerExtended : {}
			] }
			testID={ testID }>
			
			{/* Close button */}
			{ closeButton }
			
			{/* Selected timeslot(s) */}
			{ contentView }
			
			{/* Button */}
			{ buttonView }
		</View>
	);
	
	return [
		darkBackground,
		view
	];
}

const staticStyles = StyleSheet.create({
	themedPressableWidth100HeightAuto: {
		width: '100%',
		height: 'auto',
	},
});

export default ExtendingFooter
